import { AfterViewInit, Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TPAReading } from '../models/tpa-test-data.modal';

export interface TemperaturesDialogData {
  readings: TPAReading[];
}

@Component({
    selector: 'app-temperatures-dialog',
    templateUrl: './temperatures-dialog.component.html',
    styleUrls: ['./temperatures-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TemperaturesDialogComponent implements AfterViewInit {
  readonly pageSizeOptions = [50, 100, 500];

  readonly sensorKeys: string[];

  readonly displayedColumns: string[];

  readonly dataSource: MatTableDataSource<TPAReading>;

  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(
    private dialogRef: MatDialogRef<TemperaturesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TemperaturesDialogData,
  ) {
    const keys = new Set<string>();
    data.readings.forEach((reading) => {
      if (reading.temperatures) Object.keys(reading.temperatures).forEach((key) => keys.add(key));
    });
    this.sensorKeys = Array.from(keys).sort((a, b) => Number(a) - Number(b) || a.localeCompare(b));
    this.displayedColumns = ['time', ...this.sensorKeys.map((key) => this.sensorColumnId(key))];
    this.dataSource = new MatTableDataSource(data.readings);
  }

  ngAfterViewInit(): void {
    if (this.paginator) this.dataSource.paginator = this.paginator;
  }

  sensorColumnId(sensorKey: string): string {
    return `sensor-${sensorKey}`;
  }

  formatTemperature(temperature: number | undefined): string {
    return temperature !== undefined && Number.isFinite(temperature) ? temperature.toFixed(3) : '—';
  }

  close(): void {
    this.dialogRef.close();
  }
}
